import * as React from 'react';
// import styles from './index.less';

interface FShareProps {
    className?: string;
    style?: React.CSSProperties;

    onClick?(): void;
}

function FShare({className, ...props}: FShareProps) {
    return (<i
        className={['freelog', 'fl-icon-fenxiang', className].join(' ')}
        {...props}
    />);
}

export default FShare;
